export default __webpack_public_path__ + "static/media/null-img.91219279.png";